var _defs, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _g3, _g4, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 219 L 327.996094 219 L 327.996094 372.75 L 47 372.75 Z M 47 219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 127 221 L 242 221 L 242 372.75 L 127 372.75 Z M 127 221 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 207 221 L 272 221 L 272 372.75 L 207 372.75 Z M 207 221 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 97 223 L 162 223 L 162 372.75 L 97 372.75 Z M 97 223 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#642f18",
    d: "M 101.21875 145.144531 C 101.21875 145.144531 107.984375 188.546875 121.632812 232.441406 C 135.230469 276.179688 235.78125 260.203125 235.78125 260.203125 L 279.230469 246.136719 L 292.265625 236.558594 C 292.265625 236.558594 295.992188 225.644531 271.753906 190.828125 C 253.03125 163.921875 234.882812 96.8125 234.882812 96.8125 L 116.261719 115.023438 L 101.21875 145.144531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#162a45",
    d: "M 315.25 252.902344 C 312.226562 244.273438 303.210938 239.628906 303.210938 239.628906 L 230.125 219.054688 L 187.449219 233.519531 L 144.761719 219.054688 L 71.691406 239.628906 C 71.691406 239.628906 62.660156 244.273438 59.652344 252.902344 C 56.648438 261.535156 47.019531 372.71875 47.019531 372.71875 L 327.882812 372.71875 C 327.882812 372.71875 318.253906 261.535156 315.25 252.902344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1e4f1",
    d: "M 127.175781 223.3125 L 157.523438 372.71875 L 214.902344 372.71875 L 241.957031 221.914062 L 187.867188 233.664062 L 127.175781 223.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee9255",
    d: "M 187.867188 229.675781 L 224.308594 218.394531 C 218.585938 208.105469 214.757812 159.644531 214.757812 159.644531 L 187.867188 169.929688 L 160.960938 159.644531 C 160.960938 159.644531 157.152344 208.105469 151.429688 218.394531 L 187.867188 229.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9b57c",
    d: "M 187.917969 38.0625 C 137.464844 37.820312 127.578125 81.636719 130.90625 113.511719 C 131.515625 119.445312 134.988281 145.242188 140.117188 167.28125 C 142.511719 177.503906 157.25 190.105469 171.3125 198.476562 C 180.152344 203.734375 187.902344 205.214844 187.917969 205.214844 L 187.917969 205.230469 L 187.917969 205.214844 C 187.917969 205.214844 195.664062 203.734375 204.503906 198.476562 C 218.570312 190.105469 233.324219 177.503906 235.703125 167.28125 C 240.847656 145.242188 244.300781 119.445312 244.929688 113.511719 C 248.253906 81.636719 235.042969 40.714844 187.917969 38.0625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9b57c",
    d: "M 134.152344 111.519531 C 134.152344 111.519531 119.542969 97.582031 115.570312 110.859375 C 112.277344 121.789062 125.777344 153.441406 135.277344 143.105469 L 134.152344 111.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9b57c",
    d: "M 241.3125 111.519531 C 241.3125 111.519531 255.921875 97.582031 259.910156 110.859375 C 263.171875 121.789062 249.671875 153.441406 240.1875 143.105469 L 241.3125 111.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 187.867188 229.675781 C 187.867188 229.675781 159.128906 211.0625 155.867188 207.578125 C 155.867188 207.578125 150.289062 205.761719 146.980469 209.410156 C 143.667969 213.058594 127.175781 223.3125 127.175781 223.3125 L 141.546875 285.132812 C 141.546875 285.132812 172.648438 253.242188 187.867188 235.980469 L 187.867188 229.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 187.867188 229.675781 C 187.867188 229.675781 216.589844 211.0625 219.855469 207.578125 C 219.855469 207.578125 225.433594 205.761719 228.742188 209.410156 C 232.070312 213.058594 241.957031 221.914062 241.957031 221.914062 L 226.429688 289.199219 C 226.429688 289.199219 203.074219 253.242188 187.867188 235.980469 L 187.867188 229.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d3653",
    d: "M 253.351562 224.679688 L 271.753906 266.855469 L 251.839844 274.8125 L 271.753906 290.308594 L 222.667969 372.71875 L 207.15625 372.71875 L 241.957031 221.914062 L 253.351562 224.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d3653",
    d: "M 115.78125 225.898438 L 97.234375 266.855469 L 117.148438 274.8125 L 97.234375 290.308594 L 146.320312 372.71875 L 161.832031 372.71875 L 127.175781 223.136719 L 115.78125 225.898438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#894928",
    d: "M 134.214844 113.527344 C 117.46875 118.640625 101.21875 145.144531 101.21875 145.144531 C 92.3125 108.640625 104.351562 59.121094 104.351562 59.121094 C 117.96875 -0.046875 210.644531 5.710938 224.308594 11.992188 C 237.953125 18.277344 231.589844 28.757812 231.589844 28.757812 C 269.296875 38.175781 269.808594 107.308594 267.71875 138.1875 C 265.613281 169.09375 271.753906 190.828125 271.753906 190.828125 C 228.292969 186.117188 237.871094 102.582031 233.675781 84.257812 C 229.5 65.933594 216.929688 62.785156 216.929688 62.785156 C 216.929688 62.785156 193.894531 95.253906 134.214844 113.527344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudrey);
export default __webpack_public_path__ + "static/media/Audrey.0cde6a056fe6558fc77dc30269a18530.svg";
export { ForwardRef as ReactComponent };